// extracted by mini-css-extract-plugin
export default {"loginForm":"LoginForm_loginForm__aDFL+","loginStarted":"LoginForm_loginStarted__CVxqu","bg":"LoginForm_bg__ld9PA","logoutMessage":"LoginForm_logoutMessage__WHPsi"};